// extracted by mini-css-extract-plugin
export default {"chart_box":"CostEnergySavingPie_chart_box__uLJr8","spin_box":"CostEnergySavingPie_spin_box__QFCJY","empty_box":"CostEnergySavingPie_empty_box__bq1I-"};